<template>
    <div class="page">
        <div class="box">
            <div class="title">{{ article.title }}</div>
            <div class="desc">
                <div class="left">
                    <span class="time">{{ article.pubTime }}</span>
                    <span class="author">作者：{{ article.authorName }}</span>
                </div>
                <div class="right">
                    <span>
                        <span>{{ article.likeNum }}</span>
                        <img
                            v-if="!article.ifLike"
                            @click="addThumb"
                            class="thumb"
                            src="~@/assets/thumb.png"
                            alt
                        />
                        <img
                            v-else
                            @click="addThumb"
                            class="thumb"
                            src="~@/assets/thumb_active.png"
                            alt
                        />
                    </span>
                    <img
                        v-if="!article.ifCollect"
                        class="collection"
                        src="~@/assets/collection.png"
                        @click="addCollect"
                        alt
                    />
                    <img
                        v-else
                        class="collection"
                        src="~@/assets/collection_active.png"
                        @click="addCollect"
                        alt
                    />
                </div>
            </div>
            <div class="summaryBox" v-if="article.summary">
                <div class="sub_title">摘要 |</div>
                <div class="summary" v-html="article.summary"></div>
            </div>
            <div
                class="content"
                v-if="article.freeContent"
                v-html="article.freeContent"
            ></div>
            <div class="audioBox" v-if="article.fileType == 'AUDIO'">
                <my-audio
                    ref="audio"
                    :audio="audio"
                    :redirect="redirect"
                    @trySeeEvent="trySeeEvent"
                ></my-audio>
            </div>
            <div class="pay-box" v-if="free.ifFirstTime">
                <div class="top-box">
                    <div
                        class="student"
                        v-if="
                            article.target == 'STUDENT' &&
                                article.ifCanSee == false
                        "
                    >
                        <div class="top">
                            <img
                                class="studentImg"
                                src="~@/assets/student.png"
                                alt
                            />
                            <div class="price">
                                {{ article.xueyuanPrice }}<br />学员专享任意看
                            </div>
                        </div>
                        <div class="payBtn" @click="goBuyStudent">了解学员</div>
                    </div>
                    <div class="student">
                        <div class="top">
                            <img
                                class="studentImg"
                                src="~@/assets/free.png"
                                alt
                            />
                            <div class="price">
                                限免体验<br />新用户免费{{ free.day }}天畅看
                            </div>
                        </div>
                        <div class="payBtn" @click="tiyan()">立即领取</div>
                    </div>
                </div>
                <div
                    class="student footer"
                    v-if="
                        (article.target == 'PAY' ||
                            article.target == 'STUDENT') &&
                            article.ifCanSee == false
                    "
                >
                    <div class="top">
                        <img class="studentImg" src="~@/assets/suo.png" alt />
                        单篇购买 ￥{{ article.price }}
                    </div>
                    <div class="payBtn" @click="pay(article.id)">解锁全文</div>
                </div>
            </div>
            <div class="pay-box" v-else>
                <div class="top-box">
                    <div
                        class="student"
                        v-if="
                            article.target == 'STUDENT' &&
                                article.ifCanSee == false
                        "
                    >
                        <div class="top">
                            <img
                                class="studentImg"
                                src="~@/assets/student.png"
                                alt
                            />
                            <div class="price">
                                {{ article.xueyuanPrice }}<br />学员专享任意看
                            </div>
                        </div>
                        <div class="payBtn" @click="goBuyStudent">了解学员</div>
                    </div>
                    <div
                        class="student footer"
                        v-if="
                            (article.target == 'PAY' ||
                                article.target == 'STUDENT') &&
                                article.ifCanSee == false
                        "
                    >
                        <div class="top">
                            <img
                                class="studentImg"
                                src="~@/assets/suo.png"
                                alt
                            />
                            单篇购买 ￥{{ article.price }}
                        </div>
                        <div class="payBtn" @click="pay()">
                            解锁全文
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="content"
                v-if="article.ifCanSee"
                v-html="article.content"
            ></div>

            <!-- <a
                class="goQxbComment"
                href="https://lianghua.nbd.com.cn/emotion3/comment"
                v-if="article.ifCanSee && article.target == 'STUDENT'"
            >
                前往情绪宝讨论区
            </a> -->
        </div>
    </div>
</template>

<script>
    import ganhuoService from "../../service/ganhuo.service";
    import payService from "../../service/pay.service";
    import { initphotSwipe } from "../../common";
    import { Toast } from "vant";
    import MyAudio from "../../components/my-audio/my-audio.vue";
    //  import rx from "../../_rx";
    export default {
        name: "ganhuo-detail",
        components: {
            "my-audio": MyAudio,
        },
        data: function() {
            return {
                id: "",
                redirect: "",
                article: {
                    title: "",
                    summary: "",
                    target: "",
                    ifCanSee: false,
                    content: "",
                    authorName: "",
                    ifLike: false,
                    ifCollect: false,
                    likeNum: 0,
                    price: 0,
                    xueyuanPrice: "",
                    id: "",
                    fileType: "",
                    videoName: "",
                    videoTime: "",
                },
                free: {
                    ifFirstTime: false,
                    day: undefined,
                },
            };
        },
        mounted: function() {
            this.id = this.$route.params.id;
            this.redirect = `http://lianghua.nbd.com.cn/c/Wxpay/getWxapppayParams?goodsCode=ARTICLE_PAY&goodsId=${this.id}`;
            this.getArticle();
            this.getIfFirstTime();
        },

        methods: {
            trySeeEvent() {
                //  rx.emit("showFeedback", {
                //         goodsId: this.courseId,
                //         goodsCode: "STUDY",
                //         episodeId: this.id,
                //     });
            },
            tiyan() {
                payService.tiyan().then(() => {
                    Toast("领取成功");
                    location.reload();
                });
            },
            getIfFirstTime() {
                payService.ifFirstTime().then((res) => {
                    this.free = res.data;
                });
            },
            addThumb: function() {
                if (this.article.ifLike) {
                    return;
                }
                ganhuoService
                    .like({
                        id: this.id,
                    })
                    .then((res) => {
                        this.article.likeNum = res.data.likeNum;
                        this.article.ifLike = true;
                    });
            },
            addCollect: function() {
                ganhuoService.collect({ id: this.id }).then(() => {
                    if (this.article.ifCollect) {
                        this.article.ifCollect = false;
                    } else {
                        this.article.ifCollect = true;
                    }
                });
            },
            goBuyStudent() {
                this.$router.push({ path: "/pay/STUDENT?tips=1" });
            },
            pay() {
                location.href = this.redirect;
            },
            getArticle() {
                ganhuoService
                    .getArticleById({
                        id: this.id,
                    })
                    .then((res) => {
                        this.article = res.data;
                        // let link = `http://lianghua.nbd.com.cn/collegeHtml/nav/article-detail/${this.id}`;
                        initphotSwipe.call(this, ".content img");
                        this.audio = {
                            url: res.data.videoLink,
                            time: res.data.videoTime,
                            filename: res.data.videoName,
                            trySeeTime: res.data.trySeeTime,
                            ifBuy: res.data.ifCanSee,
                            ifFree: res.data.ifFree,
                        };
                    });
            },
        },
    };
</script>

<style lang="scss" scoped src="./ganhuo-detail.scss"></style>
